import React, { SVGProps } from "react";
import * as Icons from "./generated";

export type IconName = keyof typeof Icons;

export interface IconProps extends SVGProps<SVGSVGElement> {
  name: IconName;
}

const Icon = ({ name, ...props }: IconProps) => {
  const Component = Icons[name];
  return <Component {...props} />;
};

export default Icon;
